import { Injectable } from "@angular/core";

declare global {
  interface Window {
    HubSpotConversations: any;
    hsConversationsOnReady: any[];
    hsConversationsSettings: object;
  }
}

@Injectable()
export class HubspotChatService {
  // https://developers.hubspot.com/docs/api/conversation/visitor-identification
  public identifyVisitor(email: string, token: string) {
    window.hsConversationsSettings = {
      identificationEmail: email,
      identificationToken: token,
    };
  }

  public load() {
    function loadChat() {
      window.HubSpotConversations.widget.load();
    }

    if (window.HubSpotConversations) {
      loadChat();
    } else {
      window.hsConversationsOnReady = [loadChat];
    }
  }
}
